/**
 * Schema of `collection.db`, the card-content database inside every `.wflash`
 * deck file (Anki-like: notes → cards via note types).
 *
 * It travels inside the deck file, so it is part of the `.wflash` format
 * (schema_version 1 in the manifest). Change it only with a format version bump.
 */
export const COLLECTION_DB_SCHEMA = `
CREATE TABLE IF NOT EXISTS decks (
  id          TEXT    PRIMARY KEY,
  name        TEXT    NOT NULL,
  description TEXT,
  created_at  INTEGER NOT NULL,
  updated_at  INTEGER NOT NULL
) STRICT;

CREATE TABLE IF NOT EXISTS note_types (
  id     INTEGER PRIMARY KEY,
  name   TEXT    NOT NULL,
  fields TEXT    NOT NULL
) STRICT;

INSERT OR IGNORE INTO note_types VALUES
  (0, 'basic',       '["Front","Back"]'),
  (1, 'basic_rev',   '["Front","Back"]'),
  (2, 'cloze',       '["Text","Extra"]'),
  (3, 'elaboration', '["Prompt","Guide"]');

CREATE TABLE IF NOT EXISTS notes (
  id          TEXT    PRIMARY KEY,
  deck_id     TEXT    NOT NULL REFERENCES decks(id) ON DELETE CASCADE,
  note_type   INTEGER NOT NULL REFERENCES note_types(id),
  created_at  INTEGER NOT NULL,
  updated_at  INTEGER NOT NULL
) STRICT;

CREATE TABLE IF NOT EXISTS note_fields (
  note_id   TEXT    NOT NULL REFERENCES notes(id) ON DELETE CASCADE,
  field_ord INTEGER NOT NULL,
  value     TEXT    NOT NULL,
  PRIMARY KEY (note_id, field_ord)
) STRICT;

CREATE TABLE IF NOT EXISTS cards (
  id           TEXT    PRIMARY KEY,
  note_id      TEXT    NOT NULL REFERENCES notes(id) ON DELETE CASCADE,
  deck_id      TEXT    NOT NULL REFERENCES decks(id),
  template_ord INTEGER NOT NULL DEFAULT 0,
  card_type    INTEGER NOT NULL DEFAULT 0,
  created_at   INTEGER NOT NULL
) STRICT;

CREATE TABLE IF NOT EXISTS media (
  hash      TEXT    PRIMARY KEY,
  filename  TEXT    NOT NULL,
  mime_type TEXT    NOT NULL,
  size      INTEGER NOT NULL
) STRICT;

CREATE TABLE IF NOT EXISTS card_media (
  card_id TEXT    NOT NULL REFERENCES cards(id) ON DELETE CASCADE,
  hash    TEXT    NOT NULL REFERENCES media(hash),
  face    TEXT    NOT NULL,
  PRIMARY KEY (card_id, hash, face)
) STRICT;

CREATE INDEX IF NOT EXISTS idx_cards_deck ON cards(deck_id);
CREATE INDEX IF NOT EXISTS idx_cards_note ON cards(note_id);
CREATE INDEX IF NOT EXISTS idx_notes_deck ON notes(deck_id);
CREATE INDEX IF NOT EXISTS idx_nf_note    ON note_fields(note_id);
CREATE INDEX IF NOT EXISTS idx_cm_card    ON card_media(card_id);
`
